module.exports = __webpack_public_path__ + "static/media/Roboto-Light.6090d256.ttf";